

<script>
    import { PolarArea } from 'vue-chartjs'
    export default {
        extends: PolarArea,
        name: "AssessmentChart",
        props: ["datapoints"],
        mounted () {
            let options = {
                scale: {
                    ticks: {
                        min: 0,
                        max: 4,
                        display: false
                    },
                    scaleLabel: {
                        display: true
                    }
                },
                legend: {
                    'position': 'right'
                },
                layout: {
                    padding: {
                        left: 20
                    }
                }
            };
            let data = {
                labels: ['Experience','Languages','Tools','Habits','Teamwork','Managablity','Design/Analysis','Communication'],
                datasets: [
                    {
                        data: this.datapoints,
                        backgroundColor: ['#FFCC4E', '#1A535C', '#4ECDC4', '#3581B8', '#DDA15E', '#B0413E', '#8693AB', '#48876B']
                    }
                ]
            }
            this.renderChart(data, options)
        },
        data() {
            return {
            }
        }
    }
</script>

<style scoped>

</style>